export enum WebcastViewSidebarButton {
	ATTENDEES = 'Attendees',
	CHAT = 'chat',
	INFO = 'info',
	POLLS = 'polls',
	QA = 'questions',
	RTA = 'realTimeAnalytics',
	PRODUCER = 'producer',
	PRODUCER_CONTROLS = 'producerControls',
	EMBEDDED_CONTENT = 'embeddedContent',
	DTMF = 'dtmf',
	BANNERS = 'banners'
}
